import React, { memo, useCallback, useState } from 'react'
import { Global, css } from '@emotion/react'
import { Button } from '@ow/comps'
import { useTbViewStore } from '@vt/hooks'
import useAmap from '../../../../hooks/use-amap/use-cluster-area'

const LegendBar = memo(
  ({ legends, showArea, position = 'bottom', onSwitch }) => {
    const [visible, setVisible] = useState(true)
    const onClick = () => {
      setVisible(!visible)
      onSwitch(!visible)
    }
    return (
      <div
        className={`absolute right-2 ${position}-2 flex gap-2 bg-white p-2.5`}
      >
        <div className="flex  gap-2">
          {legends.map(({ mapColor, title }) => (
            <div key={title} className="flex items-center gap-2">
              <div
                className="w-4 h-4 text-sm"
                style={{ backgroundColor: mapColor, borderRadius: '50%' }}
              />
              <span>{title}</span>
            </div>
          ))}
        </div>
        {showArea && (
          <Button size="sm" type="primary" onClick={onClick}>
            {visible ? '隐藏' : '显示'}地块
          </Button>
        )}
      </div>
    )
  }
)

const MapArea = function ({ showTbDetail }) {
  const { mapType, showLabel, mainLayer } = useTbViewStore(
    (state) => state.mapConfig
  )

  const showArea = mapType === 'area'

  const { polygons } = useAmap('viewmap', {
    showArea,
    showTbDetail,
    showLabel,
  })

  if (!mainLayer) return null

  const { legends, legendsPosition } = mainLayer

  const onSwitch = useCallback((visible) => {
    if (visible) {
      polygons.current.show()
    } else {
      polygons.current.hide()
    }
  }, [])

  return (
    <div className="w-full h-full relative">
      <div id="viewmap" className="w-full h-full" />
      <LegendBar
        legends={legends}
        position={legendsPosition}
        showArea={showArea}
        onSwitch={onSwitch}
      />
      <Global
        styles={css`
          .amap-marker-label {
            border: 0;
            padding: 5px;
            font-weight: 500;
          }
        `}
      />
    </div>
  )
}

export default MapArea
